import React from 'react';
import Skeleton from '@common-web/skeleton';
import { Divider, Flex } from 'antd';

const ReturnModalSkeleton = () => {
  return (
    <Flex vertical gap={16}>
      <Skeleton width={670} height={160} />
      <Flex justify="space-between" align="start" style={{ width: '100%' }}>
        <Flex gap={12} align="center">
          <Skeleton width={92} height={92} borderRadius={4} />
          <Flex vertical gap={4}>
            <Skeleton width={200} height={16} />
            <Skeleton width={250} height={20} />
            <Skeleton width={100} height={14} />
          </Flex>
        </Flex>
        <div style={{ textAlign: 'right' }}>
          <Skeleton width={80} height={20} style={{ marginBottom: 4 }} />
          <Skeleton width={40} height={16} />
        </div>
      </Flex>
      <div style={{ marginTop: 16 }}>
        <Skeleton width={300} height={16} style={{ marginBottom: 8 }} />
        <Skeleton width={200} height={16} />
      </div>
      <div>
        <Skeleton width={80} height={24} style={{ marginBottom: 8 }} />
        <Flex justify="space-between" style={{ marginBottom: 4 }}>
          <Skeleton width={100} height={16} />
          <Skeleton width={80} height={16} />
        </Flex>
        <Flex justify="space-between">
          <Skeleton width={120} height={16} />
          <Skeleton width={80} height={16} />
        </Flex>
      </div>
      <Divider style={{ margin: '12px 0' }} />
      <Flex justify="space-between" align="center">
        <Skeleton width={120} height={24} />
        <Skeleton width={100} height={20} />
      </Flex>
    </Flex>
  );
};

export default ReturnModalSkeleton;
